"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    stockKeepingUnits: {
        names: {
            LAV: 'LAVar',
            BIB: 'BIBar',
            PET: 'PET',
            pall: 'pallar',
            kolli: 'kollin',
            st: 'st',
            kg: 'kg',
            hg: 'hg',
            g: 'g',
            liter: 'liter',
            dl: 'dl',
            cl: 'cl',
            ml: 'ml',
            ask: 'askar',
            back: 'backar',
            bal: 'balar',
            bbox: 'bboxar',
            bit: 'bitar',
            block: 'block',
            bok: 'böcker',
            bricka: 'brickor',
            bukett: 'buketter',
            bunt: 'buntar',
            burk: 'burkar',
            bytta: 'byttor',
            bägare: 'bägare',
            dunk: 'dunkar',
            fat: 'fat',
            flak: 'flak',
            flaska: 'flaskor',
            fläta: 'flätor',
            förp: 'förpackningar',
            glas: 'glas',
            hink: 'hinkar',
            kagge: 'kaggar',
            kapslar: 'kapslar',
            karta: 'kartor',
            kartong: 'kartonger',
            kassett: 'kassetter',
            klase: 'klasar',
            knippe: 'knippen',
            korg: 'korgar',
            kruka: 'krukor',
            kvartspall: 'kvartspallar',
            låda: 'lådor',
            lösvikt: 'lösvikter',
            m: 'm',
            m2: 'm2',
            nät: 'nät',
            paket: 'paket',
            platta: 'plattor',
            påse: 'påsar',
            rulle: 'rullar',
            sida: 'sidor',
            säck: 'säckar',
            tetra: 'tetra',
            tråg: 'tråg',
            tub: 'tuber',
            vagn: 'vagnar',
            Okänd: 'Okända',
        },
    },
};
